import React, { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';

const ParaImageDialog = ({ src, alt }) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <img
                src={src}
                alt={alt}
                onClick={handleClickOpen}
                style={{ cursor: 'pointer', maxWidth: '100%' }}
            />

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        padding: 0,
                    },
                }}
            >
                <DialogContent sx={{ padding: 0 }} onClick={handleClose} >
                    <img
                        src={src}
                        alt={alt}
                        style={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ParaImageDialog;